import React, { useEffect, useState, useCallback } from "react";
import { Modal } from "react-bootstrap";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import Form from "react-bootstrap/Form";
import Dropdown from "react-bootstrap/Dropdown";
import {
  CopyIcon,
  EditIcon,
  PlusIcon,
  TrashIcon,
  UploadIcon,
} from "../../components/SVGIcon";
import { label } from "yet-another-react-lightbox";
import { NotesSchema } from "./NotesSection";
import { isGenerator } from "framer-motion";
import { uploadTemplateImage } from "../../services/templateService";

export const HeaderSchema = {
  name: "Company Details",
  tag: "CompanyDetails",
  fields: [],
};

const CompanySection = ({
  singleDefaultElementTypes,
  markSectionEditing,
  updateSection,
  templateId,
  templateType,
  conversationData,
  section,
  index,
  dropdownOptions,
  isCreateReportRoute
}) => {


  console.log("passedDataExp,", singleDefaultElementTypes);
  console.log("passedDataExp,", section);
  console.log("dropdownOptions,", dropdownOptions, section.tag);
  console.log("conversationDataAAA,", conversationData);

  const [showModal, setShowModal] = useState(false);
  const [addFieldshow, setAddFieldShow] = useState(false);
  const [isDigital, setIsDigital] = useState('field');
  const [isEditModeOn, setIsEditModeOn] = useState(false);
  const [uploadingImages, setUploadingImages] = useState({});
  const [invalidFields, setInvalidFields] = useState({});
  const [newLabel, setNewLabel] = useState("");
  const [newPlaceholder, setNewPlaceholder] = useState("");
  const [newDataSource, setNewDataSource] = useState("");
  const [fields, setFields] = useState([]);
  const [labelError, setLabelError] = useState("");

  // LOCAL EDIT STATE
  const [localFields, setLocalFields] = useState([]);
  const [localSectionName, setLocalSectionName] = useState(section?.name);
  console.log(
    "111 CompanySection render",
    section.id,
    "isEditModeOn:",
    isEditModeOn
  );
  // Initialize local copy when entering edit mode

  const handleEditStart = () => {
    console.log("111 ENTER EDIT CLICKED", section.id);
    setIsEditModeOn(() => true);
    markSectionEditing(section.id, true);
  };

  useEffect(() => {
    console.log("CompanySection edit mode:", section.id, isEditModeOn);
  }, [isEditModeOn]);

  const exitEditMode = () => {
    setIsEditModeOn(() => false);
    markSectionEditing(section.id, false);
  };

  console.log("IsEditModeOn", isEditModeOn);

  const validateField = (field, rowIndex) => {
    let isInvalid = false;

    if (field.type === "text") {
      if (field.isDigital === 'digital') {
        isInvalid = !field.label?.trim() || !field.selectedDropdownValue?.trim();
      } else if (field.isDigital === 'field') {
        isInvalid = !field.label?.trim() || !field.placeholder?.trim();
      } else if (field.isDigital === 'images') {

      }
    }

    setInvalidFields((prev) => ({
      ...prev,
      [rowIndex]: isInvalid,
    }));
  };


  const isFieldInvalid = (field) => {
    if (field.type !== "text") return false;

    if (field.isDigital === 'digital') {
      return !field.label?.trim() || !field.selectedDropdownValue?.trim();
    } else if (field.isDigital === 'field') {
      return !field.label?.trim() || !field.placeholder?.trim();
    } else {
      return false;
    }
  };


  useEffect(() => {
    if (isEditModeOn) return;

    let flds = [];

    if (section.tag === "CompanyDetails" && (!section.fields || section.fields.length === 0)) {
      // flds = [{
      //   type: "arrayOfImages",
      //   name: "Company Logos",
      //   value: ["", "", ""],
      // }];
    } else {
      flds = section.fields ?? [];
    }

    setLocalFields(flds);
  }, [section, isEditModeOn]);



  // const hasInvalidFields = localFields.some((field) => {
  //   if (field.type === "text") {
  //     if (field.isDigital) {
  //       return !field.label?.trim() || !field.selectedDropdownValue?.trim();
  //     } else {
  //       return !field.label?.trim() || !field.placeholder?.trim();
  //     }
  //   }
  //   return false;
  // });


  // Sync original fields when not in edit mode
  useEffect(() => {
    if (!isEditModeOn) {
      let flds = [];
      if (section?.tag === "CompanyDetails" && (!section?.fields || section.fields.length === 0)) {
        // flds.push({
        //   type: "arrayOfImages",
        //   name: "Company Logos",
        //   value: ["", "", ""],
        // });
      } else {
        flds = section?.fields ?? [];
      }
      setFields(flds);
    }

    console.log("asdasdasdsection", section)
  }, [section, isEditModeOn]);

  // LOCAL IMAGE UPLOAD
  const handleImageUpload = async (event, sectionId, fieldIndex, imageIndex) => {
    const file = event.target.files[0];
    if (!file) return;

    const key = `${sectionId}_${fieldIndex}_${imageIndex}`;
    setUploadingImages((prev) => ({ ...prev, [key]: true }));

    try {
      if (!templateId) {
        setLocalFields((prev) => {
          const copy = [...prev];
          const field = { ...copy[fieldIndex] };
          const newValue = [...(field.value || [])];
          newValue[imageIndex] = { file, preview: URL.createObjectURL(file) };
          field.value = newValue;
          copy[fieldIndex] = field;
          console.log("setLocalFieldsCopy", copy)
          return copy;
        });
        return;
      }

      const formData = new FormData();
      formData.append("image", file);
      const imageResponse = await uploadTemplateImage(templateId, formData);
      const uploadedUrl = imageResponse?.data;
      if (!uploadedUrl) throw new Error("No image URL returned");

      setLocalFields((prev) => {
        const copy = [...prev];
        const field = { ...copy[fieldIndex] };
        const newValue = [...(field.value || [])];
        newValue[imageIndex] = uploadedUrl;
        field.value = newValue;
        copy[fieldIndex] = field;
        return copy;
      });
    } catch (error) {
      console.error("Image upload failed:", error);
      alert("Failed to upload image. Please try again.");
    } finally {
      setUploadingImages((prev) => {
        const newState = { ...prev };
        delete newState[key];
        return newState;
      });
    }
  };

  console.log("localFields", localFields)
  // LOCAL IMAGE REMOVE
  const handleImageRemove = (sectionId, fieldIndex, imageIndex) => {
    setLocalFields((prev) => {
      const copy = [...prev];
      const field = { ...copy[fieldIndex] };
      const newValue = [...(field.value || [])];
      newValue[imageIndex] = "";
      field.value = newValue;
      copy[fieldIndex] = field;
      return copy;
    });
  };

  const handleDeleteSection = () => {
    updateSection(section.id, null); // parent removes it
    setShowModal(false);
  };

  function normalizeUrl(url) {
    if (typeof url !== "string") return url;

    // Match all http / https occurrences
    const matches = url.match(/https?:\/\//g);

    // If zero or one protocol → already valid
    if (!matches || matches.length <= 1) {
      return url;
    }

    // Keep everything from the LAST http/https occurrence
    const lastIndex = url.lastIndexOf(matches[matches.length - 1]);
    return url.slice(lastIndex);
  }


  const handleChange = (e, value) => {
    setIsDigital(value);
  };

  const handleLocalFieldChange = useCallback((rowIndex, key, value) => {

    setLocalFields(prev => {
      const updated = [...prev];
      const field = prev[rowIndex];
      validateField(field, rowIndex);
      updated[rowIndex] = { ...updated[rowIndex], [key]: value };
      return updated;
    });
    //  validateField(field, rowIndex);

  }, []);



  const handleRemoveLocalField = (rowIndex) => {
    setLocalFields((prev) => prev.filter((_, idx) => idx !== rowIndex));
  };

  // // SAVE TO templateJson
  // const handleSaveUpdate = () => {

  //   // Create a new copy of the templateJson and update the specific section
  //   const updatedSections = templateJson.schema.map((schema) =>
  //     schema.id === section?.id
  //       ? { ...schema, name: localSectionName + "here", fields: [...localFields] }
  //       : schema
  //   );

  //   // Log before applying changes
  //   console.log("before update localFields tjson", { ...templateJson, schema: updatedSections });

  //   // Make sure to update the state properly with the new templateJson object
  //   setTemplateJson((prev) => {
  //     return {
  //       ...prev, // Copy the previous state
  //       schema: updatedSections, // Update the schema with the new fields
  //     };
  //   });

  //   // Log to check if the update is being applied
  //   console.log("save & update", templateJson);

  //   // Update section name in parent component if necessary
  //   handleSectionNameChange(section.id, localSectionName);

  //   // Turn off edit mode
  //   setIsEditModeOn(false);
  // };

  const handleAddImageSlot = (fieldIndex) => {
    setLocalFields((prev) => {
      const copy = [...prev];
      const field = { ...copy[fieldIndex] };
      const images = field.value || [];

      if (images.length >= 6) return prev;

      field.value = [...images, ""];
      copy[fieldIndex] = field;
      return copy;
    });
  };

  const handleRemoveImagePlaceholder = (fieldIndex, imageIndex) => {
    setLocalFields((prev) => {
      const copy = [...prev];
      const field = { ...copy[fieldIndex] };

      const images = [...(field.value || [])];

      // remove ONLY the clicked placeholder
      images.splice(imageIndex, 1);

      field.value = images;
      copy[fieldIndex] = field;

      return copy;
    });
  };

  const handleSaveUpdate = () => {
    updateSection(section.id, prevSection => ({
      ...prevSection,
      name: localSectionName,
      fields: [...localFields],
    }));
    exitEditMode();
  };

  // CANCEL – discard local changes
  const handleCancel = () => {
    exitEditMode();
  };

  // Which fields to render
  const fieldsToRender = isEditModeOn ? localFields : fields;

  return (
    <>
      <div className="d-flex align-items-center justify-content-between gap-3 p-3 border-bottom">
        {isEditModeOn ? (
          <Form.Control
            type="text"
            value={localSectionName}
            onChange={(e) => setLocalSectionName(e.target.value)}
            className="fs-20 fw-semibold mb-0 border-0 bg-transparent"
            style={{ maxWidth: "400px" }}
          />
        ) : (
          <Form.Control
            type="text"
            readOnly
            value={section?.name || ""}
            onChange={(e) => setLocalSectionName(e.target.value)}
            // onChange={(e) => handleSectionNameChange(section.id, e.target.value)}
            className="fs-20 fw-semibold mb-0 border-0 bg-transparent"
            style={{ maxWidth: "400px" }}
          />
        )}
        <div className="d-flex align-items-center gap-1">
          {!isEditModeOn && (
            <Button
              variant="icon"
              className="btn-md text-blue-600"
              onClick={handleEditStart}
            >
              <EditIcon />
            </Button>
          )}
          {!isCreateReportRoute && (
            <Button
              variant="icon"
              className="btn-md text-red-600"
              onClick={() => setShowModal(true)}
            >
              <TrashIcon />
            </Button>
          )}
        </div>
      </div>

      <div className="p-3">
        <Row className="gy-3">
          {fieldsToRender?.map((element, row) => {
            if (element.type === "text" && element.isDigital != 'images') {
              if (element.isDigital === 'digital') {
                return (
                  <Col xxl="3" md="4" sm="6" key={row}>
                    <div className={`hover-input-group ${!isEditModeOn ? "readonly" : ""}`}>
                      <div className="d-flex align-items-center flex-column gap-1">
                        <input
                          type="text"
                          readOnly={isCreateReportRoute || !isEditModeOn}
                          id={`section-title` + `${index}-${row}`}
                          // className="form-control-label"
                          className={`form-control-label ${(isEditModeOn && isCreateReportRoute) ? "readonly" : ""} ${isEditModeOn && isFieldInvalid(element) && !element.label?.trim() ? "border border-danger" : ""}`}
                          placeholder={element.label}
                          aria-label={element.label}
                          value={element.label ?? ""}
                          onChange={(e) => {
                            if (!isCreateReportRoute && isEditModeOn) {
                              handleLocalFieldChange(row, "label", e.target.value);
                            }
                          }}
                        />
                        {!isCreateReportRoute && (
                          <select
                            id={`data-source` + `${index}-${row}`}
                            disabled={!isEditModeOn}
                            // className="form-control form-select"
                            aria-label="Select Data"
                            className={`form-control form-select`}
                            placeholder={element.placeholder}
                            value={element.selectedDropdownValue ?? ""}
                            onChange={(e) =>
                              isEditModeOn && handleLocalFieldChange(row, "selectedDropdownValue", e.target.value)
                            }
                          >
                            <option value="">Select data source</option>
                            {dropdownOptions.map((opt) => (
                              <option key={opt.key} value={opt.key}>
                                {opt.label}
                              </option>
                            ))}
                          </select>
                        )}
                        {isCreateReportRoute && (
                          <input
                            type="text"
                            readOnly={!isEditModeOn}
                            id={`section-title` + `${index}-${row}`}
                            className="form-control-label"
                            placeholder={element.label}
                            aria-label={element.label}
                            value={element.value ?? ""}
                            onChange={(e) =>
                              isEditModeOn && handleLocalFieldChange(row, "value", e.target.value)
                            }
                          />
                        )}
                      </div>

                      {!isCreateReportRoute && isEditModeOn && (
                        <Button variant="reset" onClick={() => handleRemoveLocalField(row)}>
                          <img
                            src="/images/minus-circle-red.svg"
                            width={20}
                            height={20}
                            alt="Minus Rounded Red"
                          />
                        </Button>
                      )}
                    </div>
                  </Col>
                );
              } else {
                return (
                  <Col xxl="3" md="4" sm="6" key={row}>
                    <div className={`hover-input-group ${!isEditModeOn ? "readonly" : ""}`}>
                      <div className="d-flex align-items-center flex-column gap-1">
                        <input
                          type="text"
                          readOnly={isCreateReportRoute || !isEditModeOn}
                          id="section-title"
                          // className="form-control-label"
                          className={`form-control-label ${isEditModeOn && isFieldInvalid(element) && !element.label?.trim() ? "border border-danger" : ""}`}
                          placeholder={element.label ?? ""}
                          value={element.label ?? ""}
                          onChange={(e) =>
                            isEditModeOn && handleLocalFieldChange(row, "label", e.target.value)
                          }
                        />
                        <input
                          type="text"
                          readOnly={!isEditModeOn}
                          className={`form-control`}
                          placeholder={element.placeholder ? element.placeholder : "Enter Placeholder Text"}
                          value={element.value ?? element.placeholder ?? ""}
                          onChange={(e) =>
                            isEditModeOn && handleLocalFieldChange(row, "value", e.target.value)
                          }
                        />
                      </div>

                      {!isCreateReportRoute && isEditModeOn && (
                        <Button variant="reset" onClick={() => handleRemoveLocalField(row)}>
                          <img
                            src="/images/minus-circle-red.svg"
                            width={20}
                            height={20}
                            alt="Minus Rounded Red"
                          />
                        </Button>
                      )}
                    </div>
                  </Col>
                );
              }
            } else if (element.type === "arrayOfImages") {
              const images = element.value || [];
              console.log("imagesaaaa", images)
              return (
                <React.Fragment key={row}>
                  <div className="d-flex align-items-center justify-content-between gap-1 mb-2">
                    <p className="fs-14 fw-medium text-gray-600 d-flex align-items-center gap-1 mb-0">
                      Company Logos ({images?.length}){" "}
                      <OverlayTrigger placement="top" overlay={<Tooltip id="logos">Company Logos</Tooltip>}>
                        <Image
                          className="cursor-pointer"
                          src="/images/info-i-icon.svg"
                          width={20}
                          height={20}
                          alt="Info I Icon"
                          />
                      </OverlayTrigger>
                    </p>
                    {(!isCreateReportRoute && isEditModeOn) && <img
                      onClick={() => handleRemoveLocalField(row)}
                      src="/images/minus-circle-red.svg"
                      width={24}
                      height={24}
                      className="cursor-pointer"
                      alt="Minus Rounded Red2"
                    />}
                  </div>
                  <div className="d-flex flex-wrap align-items-center gap-3">
                    {images.map((img, idx) => (
                      <div key={idx} className="file-upload-box">
                        {(!img && !isEditModeOn) && (
                          <div className="w-10 h-100 bg-gray-100 rounded-3 p-4 d-flex align-items-center justify-content-center flex-column gap-3">
                            <Image src="/images/image.svg" width={32} height={32} alt="Image Icon" />
                            <span className="fs-12 text-gray-400">Logo {idx + 1}</span>
                          </div>
                        )}
                        {(isEditModeOn && !img) && (
                          <>
                            <input
                              disabled={!isEditModeOn}
                              type="file"
                              id={`file-${row}-${idx}`}
                              name={`file${idx}`}
                              onChange={(e) => handleImageUpload(e, section.id, row, idx)}
                            />
                            <label
                              htmlFor={`file-${row}-${idx}`}
                              className={!isEditModeOn && "cursor-auto"}
                            >
                              <span className="file-upload-icon">
                                <UploadIcon />
                              </span>
                              {isEditModeOn && <span className="mt-2">Upload File</span>}
                            </label>
                            {(!isCreateReportRoute && isEditModeOn) && <img
                              onClick={() => handleRemoveImagePlaceholder(row, idx)}
                              src="/images/minus-circle-red.svg"
                              width={20}
                              className="position_remove_image_placeholder"
                              height={20}
                              alt="Minus Rounded Red1"
                            />}
                          </>
                        )}
                        {img && <>
                          <div className="p-3 bg-gray-100 rounded-3 position-relative" style={{ overflow: "hidden" }}>
                            {!isCreateReportRoute && isEditModeOn && (
                              <Button
                                variant="white"
                                className="p-1 border-0 rounded-1 lh-1 position-absolute top-0 end-0 m-1 z-2"
                                onClick={() => handleImageRemove(section.id, row, idx)}
                              >
                                <Image src="/images/x.svg" width={16} height={16} alt="X Icon" />
                              </Button>
                            )}
                            {(uploadingImages[`${section.id}_${row}_${idx}`] && !isCreateReportRoute) && (
                              <div
                                className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-white bg-opacity-75"
                                style={{ zIndex: 10 }}
                              >
                                <div
                                  className="spinner-border text-primary"
                                  role="status"
                                  style={{ width: "2rem", height: "2rem" }}
                                >
                                  <span className="visually-hidden">Uploading...</span>
                                </div>
                              </div>
                            )}
                            <picture className="ratio ratio-1x1 d-block">
                              <Image
                                className="object-fit-contain"
                                src={
                                  typeof img === "string"
                                    ? normalizeUrl(img)
                                    : img?.preview
                                }
                                alt={`Uploaded Image ` + (idx + 1)}
                              />
                              {/* <label
                                htmlFor={`file-${row}-${idx}`}
                                className={!isEditModeOn && "cursor-auto"}
                              >
                                <span className="file-upload-icon">
                                  <UploadIcon />
                                </span>
                                {isEditModeOn && <span className="mt-2">Upload File</span>}
                              </label> */}
                              {/* {(!isCreateReportRoute && isEditModeOn) && <img
                                onClick={() => handleRemoveImagePlaceholder(row, idx)}
                                src="/images/minus-circle-red.svg"
                                width={20}
                                className="position_remove_image_placeholder"
                                height={20}
                                alt="Minus Rounded Red3"
                              />} */}
                            </picture>
                          </div>
                        </>}
                        {/* ➕ Add Image Button */}
                        
                      </div>
                    ))}
                    {(!isCreateReportRoute && isEditModeOn) && images.length < 6 && (
                          <Button
                            variant="outline-primary"
                            className="d-flex align-items-center justify-content-center"
                            style={{ width: 80, height: 80 }}
                            onClick={() => handleAddImageSlot(row)}
                          >
                            <PlusIcon />
                          </Button>
                        )}
                  </div>

                </React.Fragment>
              );
            }
            return null;
          })}
        </Row>

        {!isCreateReportRoute && isEditModeOn && (
          <div className="mt-4">
            <Dropdown show={addFieldshow} onToggle={setAddFieldShow}>
              <Dropdown.Toggle
                variant="reset"
                className="text-blue-600 dropdown-toggle-none d-flex align-items-center justify-content-center gap-1"
              >
                <PlusIcon />
                Add New Field
              </Dropdown.Toggle>
              <Dropdown.Menu className="add-field-dropdown-menu dropdown-menu-end">
                <h4 className="fs-16 fw-semibold px-3 pt-3 mb-1">Add New Field</h4>
                <div className="d-flex align-items-center gap-4 p-3">
                  <>
                    <Form.Check
                      className="mb-2"
                      type="radio"
                      name="add-fields"
                      label="Free Text Field"
                      id="field-1"
                      checked={isDigital === "field"}
                      onChange={(e) => handleChange(e, "field")}
                    />
                    <Form.Check
                      className="mb-2"
                      type="radio"
                      name="add-fields"
                      label="Data Source"
                      id="field-2"
                      checked={isDigital === "digital"}
                      onChange={(e) => handleChange(e, "digital")}
                    />
                    {((section?.tag === "CompanyDetails" && !fieldsToRender?.some(
                      (field) => field.type === "arrayOfImages"
                    )) && <Form.Check
                        className="mb-2"
                        type="radio"
                        name="add-fields"
                        label="Images"
                        id="images"
                        checked={isDigital === "images"}
                        onChange={(e) => handleChange(e, "images")}
                      />)}
                  </>

                </div>
                <div className="d-flex flex-column gap-2 px-3">
                  {((isDigital === 'field') || (isDigital === 'digital')) && <Form.Group>
                    <Form.Label>Label text</Form.Label>
                    <Form.Control
                      placeholder="Enter Label text"
                      value={newLabel}
                      onChange={(e) => {
                        const value = e.target.value;
                        const formattedValue =
                          value.charAt(0).toUpperCase() + value.slice(1);
                        setNewLabel(formattedValue);

                        if (formattedValue.trim()) {
                          setLabelError(""); // clear error while typing
                        }
                      }}
                      isInvalid={!!labelError}
                    />
                    <Form.Control.Feedback type="invalid">
                      {labelError}
                    </Form.Control.Feedback>
                  </Form.Group>}

                  {(isDigital === 'field') && (
                    <Form.Group>
                      <Form.Label>Placeholder Text</Form.Label>
                      <Form.Control
                        placeholder="Enter Placeholder Text"
                        value={newPlaceholder}
                        onChange={(e) => setNewPlaceholder(e.target.value)}
                      />
                    </Form.Group>
                  )}
                  {(isDigital === 'digital') && (
                    <Form.Group>
                      <Form.Label>Data Source</Form.Label>
                      <Form.Select
                        value={newDataSource}
                        onChange={(e) => setNewDataSource(e.target.value)}
                      >
                        <option value="">Select data source</option>
                        {dropdownOptions.map((opt) => (
                          <option key={opt.key} value={opt.key}>
                            {opt.label}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  )}
                </div>
                <div className="border-top p-3 mt-3 d-flex justify-content-end gap-2">
                  <Button variant="outline-secondary" size="sm" onClick={() => {
                    setAddFieldShow(false);
                    setLabelError('');
                  }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={() => {
                      if (isDigital != 'images' && !newLabel.trim()) {
                        setLabelError("Label text is required");
                        return;
                      }

                      let newField = null;

                      if (isDigital === 'field') {
                        newField = {
                          ...singleDefaultElementTypes.singleFreeText,
                          label: newLabel,
                          placeholder: newPlaceholder,
                        };
                      } else if (isDigital === 'digital') {
                        newField = {
                          ...singleDefaultElementTypes.singleDropdown,
                          label: newLabel,
                          placeholder: newPlaceholder,
                          selectedDropdownValue: newDataSource,
                        };
                      } else if (isDigital === 'images') {
                        newField = {
                          ...singleDefaultElementTypes.ArrayOfImages,
                          // label: newLabel,
                          // placeholder: newPlaceholder,
                          // selectedDropdownValue: newDataSource,
                        };
                      }

                      setLocalFields((prev) => [...prev, newField]);

                      // Reset
                      setAddFieldShow(false);
                      setIsDigital("field");
                      setNewLabel("");
                      setNewPlaceholder("");
                      setNewDataSource("");
                      setLabelError("");
                    }}

                  >
                    Add Field
                  </Button>
                </div>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        )}
      </div>

      {isEditModeOn && (
        <div className="p-3 border-top">
          <Row className="gy-2 gy-sm-0">
            <Col md="8" className="d-flex align-items-center gap-2">
              {/* {hasInvalidFields && (
                <p className="text-danger small mb-2">
                  Please fill in all label, placeholder, or data source fields before saving.
                </p>)} */}
              <Button variant="primary" className="btn-md" onClick={handleSaveUpdate}>
                Save & Update
              </Button>
              <Button variant="outline-secondary" className="btn-md" onClick={handleCancel}>
                Cancel
              </Button>
            </Col>
            {!isCreateReportRoute && (
              <Col md="4" className="text-sm-end">
                <Button variant="danger-light" className="btn-md" onClick={() => setShowModal(true)}>
                  Delete Section
                </Button>
              </Col>
            )}
          </Row>
        </div>
      )}

      <Modal
        className="info-modal"
        show={!!showModal}
        onHide={() => setShowModal(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="text-center">
            <Image src="/images/delete-badge-red.svg" alt="Delete Badge" />
            <h2 className="fs-2 fw-semibold text-gray-700 mt-5 mb-2">
              Are you sure you want to delete this section?
            </h2>
            <div className="d-flex align-items-center gap-3">
              <Button variant="primary" className="btn w-100 mt-5" onClick={handleDeleteSection}>
                Yes, Delete It!
              </Button>
              <Button variant="gray" className="btn w-100 mt-5" onClick={() => setShowModal(false)}>
                No, Not Yet
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default React.memo(CompanySection);
